import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { withTranslation } from 'react-i18next';
import starIcon from '../../images/icons/icon_reviewstar_blue.png';
import ExampleFeatured from '../../images/featured-revised-example.jpg';
import ExampleMobileFeatured from '../../images/FeaturedBannerMobile.jpg';

const bgStyle = url => {
  return {
    background: `url(${url}) no-repeat center/cover`
  };
};

const FeaturedPromo = ({ promos, t }) => {
  if (promos.length < 1) {
    return null;
  }

  // Using example image for local testing
  // promos.forEach(promo => {
  //   promo.img_url.desktop = ExampleFeatured;
  //   promo.img_url.mobile = ExampleMobileFeatured;
  // });

  const notSingle = promos.length > 1;
  const invalidData = promos.some(
    promo => !(promo.img_url && promo.img_url.desktop && promo.img_url.mobile)
  );

  const promoDisplay = (
    { desktop, mobile } // eslint-disable-line
  ) => (
    <>
      <div
        className='fe-featured-promo-item desktop'
        style={bgStyle(desktop)}
      />
      <div className='fe-featured-promo-item' style={bgStyle(mobile)} />
    </>
  );

  return invalidData ? null : (
    <section className='fe-trip-featured-promos'>
      <div className='container'>
        <h3 className='fe-home-subheading'>{t('home:featuredExperiences')}</h3>
        <Carousel
          className='fe-home-featured-promos single'
          showArrows={notSingle}
          showStatus={false}
          showIndicators={notSingle}
          showThumbs={false}
          infiniteLoop={notSingle}
          autoPlay={notSingle}
          transitionTime={400}
          emulateTouch={notSingle}
          swipeScrollTolerance={50}
          interval={5000}
        >
          {promos.map((promo, i) => {
            const isExternalLink = promo.url && /^http/.test(promo.url);
            return (
              <div key={i} className='fe-featured-promo-item-container'>
                {promo.url ? (
                  isExternalLink ? (
                    <a href={promo.url}>{promoDisplay(promo.img_url)}
                      {(promo.is_new) ? (
                        <div className='fe-featured-new-promo'>
                          <img className='fe-featured-new-promo-icon' src={starIcon}/> NEW
                        </div>
                      ) : null}
                    </a>
                  ) : (
                    <Link to={promo.url}>{promoDisplay(promo.img_url)}
                      {(promo.is_new) ? (
                        <div className='fe-featured-new-promo'>
                          <img className='fe-featured-new-promo-icon' src={starIcon}/> NEW
                        </div>
                      ) : null}
                    </Link>
                  )
                ) : (
                  <>
                    {promoDisplay(promo.img_url)}
                    {(promo.is_new) ? (
                      <div className='fe-featured-new-promo'>
                        <img className='fe-featured-new-promo-icon' src={starIcon}/> NEW
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            );
          })}
        </Carousel>
      </div>
    </section>
  );
};

FeaturedPromo.propTypes = {
  promos: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ tripState }) => ({
  promos: tripState.featuredPromos
});

export default withTranslation()(connect(mapStateToProps)(FeaturedPromo));
